import { useQuery } from '@tanstack/react-query'
import { TechnicianProfile } from '@myapp/contract'
import { technicianProfileKeys } from '../keys'
import { technicianProfileApi } from '../service'

/**
 * Every active technician's profile — working days and shift boundaries.
 *
 * The disposition board gets the same three fields for free on every `GET /schedule`
 * (`ScheduleTechnicianSchema`), so it has no need of this. This exists for the places that hold a
 * technician id and nothing else — `features/appointment-upsert`, which also opens from
 * `pages/work-order-detail` where no calendar query runs.
 *
 * A profile changes about never, so it is cached for the session rather than refetched: a shift
 * edited in Benutzerverwaltung is a page reload away, and a background refetch mid-form could
 * re-derive a Ganztägig Termin under the user's hands.
 */
export const useTechnicianProfiles = (options?: { enabled?: boolean }) =>
  useQuery({
    queryKey: technicianProfileKeys.list(),
    queryFn: async (): Promise<TechnicianProfile[]> => {
      const { data } = await technicianProfileApi.list()
      return data
    },
    // The upsert modals stay mounted and closed for the whole life of the disposition board, so an
    // ungated query here would be a request on every board load for a form nobody opened.
    enabled: options?.enabled ?? true,
    staleTime: Infinity,
  })
